export default {
  'hero.title': 'Alimenter la croissance grâce à la technologie et aux investissements stratégiques',
  'hero.subtitle': 'Flexy Group est une entreprise technologique dynamique spécialisée dans les solutions de paiement numérique de pointe, les logiciels bancaires sophistiqués et les investissements technologiques stratégiques qui transforment l\'industrie.',
  'hero.exploreSolutions': 'Explorer nos solutions',
  'hero.investmentPortfolio': 'Portefeuille d\'investissement',
};
